function mathFunction(container) {
  if (window.MathJax && window.MathJax.typesetPromise) {
    if (container) {
      // ✅ Only typeset inside this container
      return window.MathJax.typesetPromise([container]);
    } else {
      // ❌ Avoid this unless you really want the whole page typeset
      return window.MathJax.typesetPromise();
    }
  }
}
export default mathFunction;
